<template>
  <div v-if="widget.visible" :id="widget.id" ref="widget" class="ui-widget-body relative">
    <div class="widget-tag absolute top-0 left-0 px-2 py-1 text-white z-20 rounded-br" :class="selected && 'block'">
      {{ $t(`model.${menuInfo.title}`) }}
    </div>
    <div v-if="canDrag && (selected && !show) && $store.getters.isDesktop" class="tools-area flex items-center z-20">
      <div class="fun-item move-btn w-[32px] h-[32px] text-black rounded-full bg-textColor-6 hover:bg-white cursor-row-resize flex items-center justify-center">
        <i class="el-icon-rank text-18"></i>
      </div>
      <div class="fun-item ml-4 w-[32px] h-[32px] text-black rounded-full bg-textColor-6 hover:bg-white cursor-pointer flex items-center justify-center" @click="handleShowDeleteDialog">
        <i class="el-icon-delete text-18"></i>
      </div>
    </div>
    <add-block v-if="widget.name !== WidgetModelNames.DialogCollectionWidgetModel" :model="model" :selected="selected" :can-drag="canDrag" :index="index" :widget="widget" @add="onWidgetAdd" @show-add-block="handleShowAddBlock" />
    <div class="widget-wrap" :class="{'active': selected}">
      <slot />
    </div>
  </div>
</template>

<script>
import addBlock from "~/components/addBlock"
import { WidgetModelNames } from '~/enums/siteEnum'
export default {
  name: "UiWidgetBody",
  components: {
    addBlock
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    canDrag: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0,
    },
    widget:{
      type: Object,
      default() {
        return {
          getMenuInfo(){
            return {
              draggable: true
            }
          }
        };
      }
    },
    model: {
      type: Object,
      required: true,
      default() {
        return {
          getCanAddWidget() {
          }
        }
      }
    }
  },
  data() {
    return {
      show: false,
    }
  },
  computed: {
    WidgetModelNames() {
      return WidgetModelNames
    },
    menuInfo() {
      return this.widget?.getMenuInfo() || {}
    }
  },
  watch: {
    selected() {
      this.show = false
    }
  },
  methods: {
    handleShowDeleteDialog() {
      this.SiteMenu.openDeleteBlockDialog()
    },
    onWidgetAdd(model, index) {
      this.$emit('add', model, index)
    },
    handleShowAddBlock(index) {
      this.$emit('show-add-block', index)
    },
    addWidgetByIndex(item) {
      this.model.addWidgetByIndex(item.model, this.index + 1)
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
.ui-widget-body {
  position: relative;
  .widget-tag {
    background-color: rgba(245, 63, 63, 0.7);
    display: none;
  }
  &:hover {
    .widget-tag {
      display: block;
    }
  }
  .tools-area {
    position: absolute;
    top: 40px;
    left: 40px;
    cursor: pointer;
    // 提升可读性与层次
    backdrop-filter: saturate(120%) blur(6px);
    -webkit-backdrop-filter: blur(6px);
    
    .fun-item {
      transition: transform .15s ease, box-shadow .15s ease, background-color .15s ease, opacity .2s ease;
      box-shadow: 0 6px 18px fade(@primary-1, 18%), 0 2px 6px fade(#000, 10%);
      border: 1px solid fade(#000, 8%);
      color: #222;

      i {
        transition: color .15s ease, opacity .2s ease;
      }

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 8px 22px fade(@primary-1, 22%), 0 3px 8px fade(#000, 12%);
        color: @primary-1;
      }

      &:active {
        transform: translateY(0);
        box-shadow: 0 4px 14px fade(@primary-1, 20%), 0 2px 6px fade(#000, 12%);
      }

      &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px fade(@primary-1, 30%), 0 6px 18px fade(@primary-1, 18%);
      }

      &.move-btn {
        cursor: move;
      }
    }
  }
  .widget-wrap {
    border: 1px solid transparent;
    &:hover {
      border: 1px dashed @error-color;
    }
    &.active {
      border: 1px dashed @error-color;
    }
  }
}
</style>
